import { parentPasswordModalActionTypes } from '@/components/modals/parentPasswordModal/Constants';

export function openParentPasswordModal(onSuccessPath: string) {
	return {
		type: parentPasswordModalActionTypes.OPEN_PARENT_PASSWORD_MODAL,
		payload: { onSuccessPath },
	};
}

export function closeParentPasswordModal() {
	return {
		type: parentPasswordModalActionTypes.CLOSE_PARENT_PASSWORD_MODAL,
	};
}

export function updateParentVerification(isVerified: boolean) {
	return {
		type: parentPasswordModalActionTypes.UPDATE_PARENT_VERIFICATION,
		payload: {
			isVerified,
		},
	};
}

export function validateParentPasswordRequest(
	password: string,
	rememberMe: boolean,
	onSuccessPath: string | null = null,
) {
	return {
		type: parentPasswordModalActionTypes.VALIDATE_PARENT_PASSWORD_REQUEST,
		payload: {
			password,
			rememberMe,
			onSuccessPath,
		},
	};
}

export function validateParentPasswordSuccess() {
	return {
		type: parentPasswordModalActionTypes.VALIDATE_PARENT_PASSWORD_SUCCESS,
	};
}

export function validateParentPasswordError(error: string) {
	return {
		type: parentPasswordModalActionTypes.VALIDATE_PARENT_PASSWORD_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}

export function resetParentPasswordValidation() {
	return {
		type: parentPasswordModalActionTypes.RESET_PARENT_PASSWORD_VALIDATION,
	};
}
